import { createReducer, on } from '@ngrx/store';
import { setChartData } from 'ChartApp/ts/features/fund-chart-page-shared/state/reducers/chart-data/chart-data.actions';
import { setFundChartNote } from 'ChartApp/ts/features/fund-chart-page-shared/state/reducers/note/note.actions';
export const note = createReducer('', on(setChartData, (state, { chartData }) => chartData.params.note), on(setFundChartNote, (state, action) => action.note));
